import WikiSection from "./WikiSection";

import "./WikiSection.scss";

export * from "./WikiSection.types";

export { WikiSection };
